import * as React from 'react';
import { SVGProps } from 'react';

const IconDisconnectionSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2.818 4.94.89 6.866a3 3 0 1 0 4.243 4.243l1.22-1.22-.707-.708-1.22 1.22a2 2 0 1 1-2.829-2.828l1.928-1.928-.707-.707zm8.292.193L9.182 7.06l-.707-.707 1.928-1.929a2 2 0 0 0-2.829-2.828l-1.22 1.221-.708-.707L6.867.89a3 3 0 1 1 4.243 4.243zM5.651 3.484 3.936.883l-.603.603 1.715 2.6.603-.602zM2.339 2.381l1.81 1.206-.604.603-1.81-1.206.604-.603zm5.447 6.073 1.81 1.206.602-.603L8.39 7.851l-.603.603zm-1.469.03 1.793 2.641.603-.603L6.92 7.881l-.603.603z" />
  </svg>
);
export default IconDisconnectionSizeXs;
